import * as React from 'react';
const PerderePesoIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M99.9 136.11c0 .05.04.09.09.09s.09-.04.09-.09-.04-.09-.09-.09-.09.04-.09.09M109.52 78.72c9.66.44 17.1 7.1 22.87 14.71 1.2 1.59 2.09 3.24 2.85 4.89 2.11 4.56 4.05 10.38 4.59 15.37 1.19 11 .86 19.07-7.67 19.42"
      className="prefix__cls-2"
    />
    <path
      d="M115.26 87.89c5.07 4.35 17.49 14.3 9.45 20.32 7.53 11.06 10.85 20.53 5.23 30.32-1.72 3.01-4.31 5.6-7.86 7.56"
      className="prefix__cls-2"
    />
    <path
      d="M124.73 108.21c-1.53 1.2-5.68 1.85-8.81.35"
      className="prefix__cls-2"
    />
    <circle cx={100} cy={68.1} r={14.24} className="prefix__cls-2" />
    <path
      d="M90.48 78.77c-9.66.44-17.1 7.1-22.87 14.71-1.2 1.59-2.09 3.24-2.85 4.89-2.11 4.56-4.05 10.38-4.59 15.37-1.19 11-.86 19.07 7.67 19.42"
      className="prefix__cls-2"
    />
    <path
      d="M117.15 138.39c-.62-.95-1.53-2.52-2.05-3.58m-2.27-6.16c-.33-1.27-.6-2.6-.82-3.96m-.71-6.93c-.04-1.49 0-2.61.02-3.2M124.73 122.48l-6.75 2.79M122.16 127.29l-4.18-2.02M119.52 120.89l-1.54 4.38"
      className="prefix__cls-1"
    />
    <path
      d="M77.92 146.14c-3.55-1.95-6.14-4.54-7.86-7.56-5.63-9.79-2.31-19.26 5.23-30.32-8.06-6.04 4.46-16.05 9.51-20.37"
      className="prefix__cls-2"
    />
    <path
      d="M75.27 108.26c1.53 1.2 5.68 1.85 8.81.35"
      className="prefix__cls-2"
    />
    <circle cx={100} cy={68.15} r={14.24} className="prefix__cls-2" />
    <path
      d="M84.96 134.81c-.53 1.05-1.43 2.63-2.05 3.58m5.14-13.7c-.22 1.36-.49 2.69-.82 3.96m1.51-14.09c.03.6.07 1.71.02 3.2M75.33 122.48l6.74 2.78M77.9 127.29l4.17-2.03M80.54 120.89l1.53 4.37"
      className="prefix__cls-1"
    />
  </svg>
);
export default PerderePesoIcon;
